// extracted by mini-css-extract-plugin
export default {"link":"cK-z","disabled":"dK-z"};